<ul class="nav nav-tabs fz-body" [class.nav-fill]="config.tabs.length > 2" [class.nav-pills]="config.tabs.length > 2" *ngIf="config">
  <ng-container *ngFor="let tab of config.tabs">
  <li class="nav-item" [class.active-cursor]="tab.enabled" *ngIf="tab.enabled">
      <a class="nav-link"  [class.disabled]="!tab.enabled" [class.active]="tab.stage===stage && tab.step===step" (click)="go(tab.identifier)">{{ tab.description | i18n}}</a>
  </li>
  </ng-container>
</ul>
